import { createTypedAsyncThunk, withOrgId } from "../utils/actions";
import * as API from "@/data/api/dashboards";
import { RequestParams, TDashboardItem, TDashboardPayload } from "@/data/types";
import { State } from "../state/state";

export const getAllDashboardsAsync = createTypedAsyncThunk<
  { items: TDashboardItem[] },
  RequestParams,
  { state: State }
>("dashboards/getAllDashboards", async (params, { getState }) => {
  return API.getAllDashboards(withOrgId(getState, params));
});

export const createDashboardAsync = createTypedAsyncThunk<
  TDashboardItem,
  { params?: RequestParams; payload: TDashboardPayload },
  { state: State }
>("dashboards/createDashboard", async ({ params = {}, payload }, { getState }) => {
  return API.createDashboard(withOrgId(getState, params), payload);
});

export const getDashboardByIdAsync = createTypedAsyncThunk<
  TDashboardItem,
  { dashboardId: string; params?: RequestParams },
  { state: State }
>("dashboards/getDashboardById", async ({ dashboardId, params = {} }, { getState }) => {
  return API.getDashboardById(dashboardId, withOrgId(getState, params));
});

export const updateDashboardAsync = createTypedAsyncThunk<
  TDashboardItem,
  { dashboardId: string; params?: RequestParams; payload: Partial<TDashboardPayload> },
  { state: State }
>("dashboards/updateDashboard", async ({ dashboardId, params = {}, payload }, { getState }) => {
  return API.updateDashboard(dashboardId, withOrgId(getState, params), payload);
});

export const deleteDashboardAsync = createTypedAsyncThunk<
  { success: boolean },
  { dashboardId: string; params?: RequestParams },
  { state: State }
>("dashboards/deleteDashboard", async ({ dashboardId, params = {} }, { getState }) => {
  return API.deleteDashboard(dashboardId, withOrgId(getState, params));
});